// File: config.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items used throughout the application.
// Other Contributors:

import { baseConfig } from './config.base';
import { idleTimer } from './config.idleTimer';
import { navItems } from './config.navbar';
import { breadcrumbs } from './config.breadcrumbs';
import { appBarUserMenu } from './config.appBarUserMenu';
import { notifications } from './config.notification';
import { tprecmConfig } from './config.tprecm';

export const config = {
    ...baseConfig,
    ...tprecmConfig,
    idleTimer,
    navItems,
    breadcrumbs,
    appBarUserMenu,
    notifications
};